//This file sets up the dependencies which are required for everything always.
//In practice, there should never be anything in this ever, but past decisions require this kind of thing

//global jquery
import $ from "jquery"
window.$ = $;
window.jQuery = $;

//Kendo UI
import "@progress/kendo-ui/js/kendo.all"
import "./kendo-ui-license"
import "@progress/kendo-theme-default/dist/all.css";
import "@progress/kendo-font-icons/dist/index.css";
